import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useQuery } from '@apollo/client'
import Infos from './Infos'
import Estimations from './Estimations'
import Template from '../../components/Template'
import { DomiciliationType } from '../../types'
import CentredLoader from '../../components/CentredLoader'
import { PROSPECT_SHOW_QUERY } from '../../graphql/Estimation'
import { Alert } from 'antd'

interface Props {
  domiciliationId: number
  hubspotDropboxEmail?: string
  readOnlyForm: boolean
}

interface ProspectData {
  domiciliation: DomiciliationType
}

interface ProspectVars {
  id: number
}

const Show = (props: Props): JSX.Element => (
  <Template>
    <ShowWrapped {...props} />
  </Template>
)

const ShowWrapped = (props: Props): JSX.Element => {
  const { loading, data, refetch } = useQuery<ProspectData, ProspectVars>(
    PROSPECT_SHOW_QUERY,
    {
      variables: { id: props.domiciliationId },
    }
  )

  const [valid, setValid] = useState(false)

  const [estimationVariables, setEstimationVariables] = useState({})

  const updateEstimationVariables = (data: any) => {
    setEstimationVariables(data)
    checkValidity(data)
  }

  const checkValidity = (item: any) => {
    setValid(
      !!item.addressId &&
        !!item.legalStatusId &&
        !!item.mailServiceId &&
        !!item.forwardingCountry &&
        !!item.actionType
    )
  }

  useEffect(() => {
    if (data && data.domiciliation) {
      updateEstimationVariables({
        forwardingCountry: data.domiciliation.forwardingAddress?.country,
        addressId: data.domiciliation.address?.id,
        legalStatusId: data.domiciliation.society?.legalStatus?.id,
        mailServiceId: data.domiciliation.mailService?.id,
        actionType: data.domiciliation.society?.actionType,
      })
    }
  }, [data])

  if (loading) return <CentredLoader tip="Loading..." size="large" />
  return (
    <Wrapper>
      {data && (
        <React.Fragment>
          <MainContentWrapper>
            <Infos
              domiciliation={data.domiciliation}
              refetchDomiciliation={refetch}
              estimationVariables={estimationVariables}
              setEstimationVariables={updateEstimationVariables}
              readOnlyForm={props.readOnlyForm || false}
            />
            {valid && (
              <Estimations
                domiciliation={data.domiciliation}
                estimationVariables={estimationVariables}
                setEstimationVariables={updateEstimationVariables}
                hubspotDropboxEmail={props.hubspotDropboxEmail}
              />
            )}
            {!valid && (
              <div className="ant-row" style={{ margin: '32px' }}>
                <Alert
                  type="info"
                  message="Veuillez remplir les données obligatoires"
                />
              </div>
            )}
          </MainContentWrapper>
        </React.Fragment>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #ffffff;
  display: flex;

  .page-content {
    background: white !important;
  }
`

const MainContentWrapper = styled.div`
  width: 100%;

  h4 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 16px;
  }
`

export default Show
